var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5929 12.337L21.7514 29.7996H26.2975L29.1393 12.337H24.5929ZM17.9264 12.337L13.592 24.3476L13.0793 21.7613L13.0796 21.7622L12.9667 21.1825C12.4421 20.052 11.2271 17.9033 8.93303 16.0696C8.25478 15.5275 7.57109 15.065 6.91016 14.6698L10.8495 29.7996H15.5862L22.8195 12.337H17.9264ZM35.6692 17.1849C35.6692 15.2106 40.0967 15.4643 42.0422 16.5364L42.6909 12.7859C42.6909 12.7859 40.6888 12.0244 38.6018 12.0244C36.3456 12.0244 30.9881 13.0111 30.9881 17.8053C30.9881 22.3173 37.2762 22.3733 37.2762 24.7422C37.2762 27.111 31.6364 26.6877 29.7752 25.1934L29.0988 29.1135C29.0988 29.1135 31.1287 30.1002 34.231 30.1002C37.3329 30.1002 42.0139 28.4932 42.0139 24.1218C42.0139 19.5816 35.6692 19.1588 35.6692 17.1849ZM54.2208 12.337H50.5655C48.8777 12.337 48.4667 13.6384 48.4667 13.6384L41.6869 29.7996H46.4255L47.3734 27.2059H53.153L53.6861 29.7996H57.8605L54.2208 12.337ZM48.6835 23.6224L51.0724 17.0875L52.4163 23.6224H48.6835Z",
    fill: "#005BAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6135 13.9833C11.6135 13.9833 11.4253 12.4072 9.4164 12.4072H2.11772L2.03223 12.7034C2.03223 12.7034 5.54055 13.4186 8.90635 16.098C12.1228 18.6589 13.1721 21.8512 13.1721 21.8512L11.6135 13.9833Z",
    fill: "#F6AC1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment6);
export default __webpack_public_path__ + "static/media/payment6.8fc774289eb64349bfb89a47cece9ece.svg";
export { ForwardRef as ReactComponent };